module.exports = __webpack_public_path__ + "img/lucky5ex_bg.08a73714.png";